// import { ServiceProvider } from "./../../providers/service/service";
import { ViewHeaderPage } from "./../view-header/view-header";
import { HomePage } from "./../home/home";
import { Storage } from "@ionic/storage";
import { Component } from "@angular/core";
import {
  AlertController,
  IonicPage,
  ModalController,
  NavController,
} from "ionic-angular";
import { VideoTutorialModalPage } from "../video-tutorial-modal/video-tutorial-modal";

@IonicPage()
@Component({
  selector: "page-manaul",
  templateUrl: "manaul.html",
})
export class ManaulPage {
  plaza_name = "Plaza A";
  plaza = "A";
  round = 1;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    // private services: ServiceProvider,
    public alertController: AlertController,
    public modalController: ModalController
  ) {
    this.storage.get("info").then((info) => {
      this.plaza_name = info.team.plaza_name;
      if (this.plaza_name == "Plaza A") {
        this.plaza = "A";
      } else if (this.plaza_name == "Plaza B") {
        this.plaza = "B";
      } else if (this.plaza_name == "Plaza C") {
        this.plaza = "C";
      } else if (this.plaza_name == "Plaza D") {
        this.plaza = "D";
      } else if (this.plaza_name == "Plaza E") {
        this.plaza = "E";
      } else if (this.plaza_name == "Plaza F") {
        this.plaza = "F";
      }
    });

    this.storage.get("roundGame").then((round) => {
      this.round = round;
    });
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    // this.storage.get("video").then((video) => {
    //   console.log(video);
    // });
  }

  // rentOutSpace() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[18].video_url, options);
  //   });
  // }

  // investInSocial() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[19].video_url, options);
  //   });
  // }

  // investInTheme() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[20].video_url, options);
  //   });
  // }

  // checkPlazaMap() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[21].video_url, options);
  //   });
  // }

  // CollectRentFee() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[22].video_url, options);
  //   });
  // }

  // removeSocialShop() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[23].video_url, options);
  //   });
  // }

  // addSocialTicket() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[24].video_url, options);
  //   });
  // }

  // changeTheme() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[25].video_url, options);
  //   });
  // }

  async viewVdo(id) {
    this.storage.get("video").then(async (video) => {
      console.log("video===>", video);
      this.navCtrl.push(VideoTutorialModalPage, {
        id: id,
        vdo: video[id].video_url,
      });
    });
  }

  backPage() {
    this.navCtrl.push(HomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.push(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/manaul/manaul.ts